import { render, staticRenderFns } from "./AppReviewVideo.vue?vue&type=template&id=482d1bfb&scoped=true"
import script from "./AppReviewVideo.vue?vue&type=script&lang=js"
export * from "./AppReviewVideo.vue?vue&type=script&lang=js"
import style0 from "./AppReviewVideo.vue?vue&type=style&index=0&id=482d1bfb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482d1bfb",
  null
  
)

export default component.exports